/* eslint-disable max-lines */
import CustomSelect from "@components/elements/CustomSelect/CustomSelect"
import { isEmpty } from "lodash"
import ArrowDown from "@components/icons/ArrowDown"
import ArrowUp from "@components/icons/ArrowUp"
import LocationIcon from "@components/icons/LocationIcon"
import SearchIcon from "@components/icons/SearchIcon"
import { addTraillingSlash, createResultsUrl, formatCurrencyOption, getSizetext } from "@lib/searchUtils"
import { formatNumber } from "@lib/utils"
import clsx from "clsx"
import { navigate } from "gatsby"
import React, { useEffect, useState } from "react"
import { Dropdown } from "react-bootstrap"
import Slider from "react-slick"
import ReactSlider from "react-slider"
import { useGlobalStore } from "../../../stores/globalStore"
import { SizeConvert, calcPrice } from "../../CurrencyConverter/CurrConvertPrice"
import { useAmenityCard, useOffAmenityCard } from "../AmenitiesSelect/AmenitiesSelect"
import SearchAutoSuggest from "../PredictiveSearch/SearchAutoSuggest"
import useAreaMultiSelect from "../PredictiveSearch/useAreaMutiSelect"
import useSearch from "../hooks/useSearch"
import useUrlData from "../hooks/useUrlData"
import { usePropertyStore } from "../store/propertyStore"
import { Tab, Tabs } from "./TabFilter/TabFilter"
import {
  amenitiesOptions,
  currencyTypeOptionsSymbols,
  currencyTypeOptionsBudget,
  propertySaleRentUrlOptions,
  sortOptions,
} from "./filterOptions"
import useFeatures from "@hooks/dataHooks/useFeatures"

export const SearchInput = () => {
  const {
    searchText,
    setSearchText,
    areasSuggestionList,
    handleSelectArea,
    setSearchSlug,
  } = useAreaMultiSelect()

  return (
    <div className="filter search-box">
      <LocationIcon />
      <SearchAutoSuggest
        placeholder="Area, project or community"
        handleSelectArea={handleSelectArea}
        searchText={searchText}
        setSearchText={setSearchText}
        areasSuggestionList={areasSuggestionList}
        setSearchSlug={setSearchSlug}
      />
    </div>
  )
}

export const CurrencyTypeSelect = ({setShowModal, isburger, isFooter}) => {
  const { currencyType, setCurrencyType, currencyTypeOptions } = useGlobalStore(
    (state) => ({
      currencyType: state.currencyType,
      setCurrencyType: state.setCurrencyType,
      currencyTypeOptions: state.currencyTypeOptions,
    })
  )
  // let currencyTypeSymbol;
  const {
    minPriceOptions,
    maxPriceOptions,
    setMinPriceOptions,
    setMaxPriceOptions,
    setMinPrice,
    setMaxPrice,
    minPrice,
    maxPrice,
  } = usePropertyStore((state) => ({
    setMinPriceOptions: state.setMinPriceOptions,
    setMaxPriceOptions: state.setMaxPriceOptions,
    minPriceOptions: state.minPriceOptions,
    maxPriceOptions: state.maxPriceOptions,
    setMinPrice: state.setMinPrice,
    setMaxPrice: state.setMaxPrice,
    minPrice: state.minPrice,
    maxPrice: state.maxPrice,
  }))
  useEffect(() => {
    const convertedMinPriceOptions = minPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )
    if (!isEmpty(convertedMinPriceOptions))
      setMinPriceOptions(convertedMinPriceOptions)
    const convertedMinPrice = {
      label:
        minPrice?.value === ""
          ? minPrice?.label
          : `${currencyType?.value} ${parseInt(
              calcPrice(minPrice?.value, currencyType?.value, "AED"),
              10
            ).toLocaleString("en-US")}`,
      value: minPrice?.value,
    }
    if (!isEmpty(convertedMinPrice)) setMinPrice(convertedMinPrice)
    const convertedMaxPriceOptions = maxPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMaxPriceOptions))
      setMaxPriceOptions(convertedMaxPriceOptions)
    const convertedMaxPrice = {
      label:
        maxPrice?.value === ""
          ? "No Max"
          : `${currencyType?.value} ${parseInt(
              calcPrice(maxPrice?.value, currencyType?.value, "AED"),
              10
            ).toLocaleString("en-US")}`,
      value: maxPrice?.value,
    }

    if (!isEmpty(convertedMaxPrice)) setMaxPrice(convertedMaxPrice)
    //  currencyTypeSymbol = currencyType?.value === "AED" ? { value: "AED", label: "UAE Dirams - AED د.إ" } :
    // currencyType?.value === "EUR" ?
    // { value: "EUR", label: "Euros - EUR €" } :
    // currencyType?.value === "GBP" ?
    // { value: "GBP", label: "Pound Sterling - GBP £" } :
    // currencyType?.value === "USD" ?
    // { value: "USD", label: "US Dollars - USD $" } : { value: "AED", label: "UAE Dirams - AED د.إ" }
  }, [currencyType])

  return (
    <CustomSelect
      options={currencyTypeOptionsSymbols}
      value={currencyType}
      className="filter-select currency-type-select"
      onChange={(e) => {
        setCurrencyType(e)
        isburger ? setShowModal(false) : null
        localStorage.setItem("currency", JSON.stringify(e))
      }}
    />
  )
}


export const CurrencyTypeSelectBudget = () => {
 
 const [ currencyBudget, setCurrencyBudget ] = useState({ value: "AED", label: "AED" })
  

  return (
    <CustomSelect
      options={currencyTypeOptionsBudget}
      value={currencyBudget}
      className="filter-select currency-type-select"
      onChange={(e) => {
        setCurrencyBudget(e)
        localStorage.setItem("currencyBudget", JSON.stringify(e))
      }}
    />
  )
}

export const LanguageTypeSelect = ({setShowModal, isburger}) => {
  const { language, setLanguage, languageOptions } = useGlobalStore(
    (state) => ({
      language: state.language,
      setLanguage: state.setLanguage,
      languageOptions: state.languageOptions,
    })
  )
 
 

  return (
    <CustomSelect
      options={languageOptions}
      value={language}
      className="filter-select currency-type-select"
      onChange={(e) => {
        setLanguage(e)
        isburger ? setShowModal(false) : null
        localStorage.setItem("language", JSON.stringify(e))
      }}
    />
  )
}


export const SizeTypeSelect = ({setShowModal, isburger}) => {
  const { setSizeType, sizeType} = useGlobalStore()
 
  const sizeOptions = [ { value: "mToFt", label: "SQ FT" },
    { value: "ftToM", label: "SQ M" },
  ]

  return (
    <CustomSelect
      options={sizeOptions}
      value={sizeType === "ftToM" ? { value: "ftToM", label: "SQ M" } : { value: "mToFt", label: "SQ FT" }}
      className="filter-select currency-type-select"
      onChange={(e) => {
        setSizeType(e.value)
        isburger ? setShowModal(false) : null
        localStorage.setItem("sizeType", e.value)
      }}
    />
  )
}

export const BuyRentSelect = () => {
  const pType = usePropertyStore((state) => state.pType)
  const pDepartment = usePropertyStore((state) => state.pDepartment)

  return (
    <CustomSelect
      options={propertySaleRentUrlOptions}
      value={
        pType === "sales"
          ? propertySaleRentUrlOptions[0]
          : propertySaleRentUrlOptions[1]
      }
      onChange={(option) => {
        let url = ""

        if (pDepartment === "commercial") {
          // url = `${commercialPropertiesURL}${option.value}/`
        } else if (pDepartment === "residential") {
          url = option.value
          // url = `${propertiesURL}${option.value}`
        }

        navigate(addTraillingSlash(url))
            // url = addTraillingSlash(url)
            // window.location.href = url
            // window.location.replace(url)
        // window.location.href = addTraillingSlash(`${url}/`)
        
      }}
      className="filter-select buy-rent-select"
    />
  )
}

export const BuildingTypeSelect = () => {
  const { buildingType, setBuildingType, buildingTypeOptions } =
    usePropertyStore((state) => ({
      buildingType: state.buildingType,
      setBuildingType: state.setBuildingType,
      buildingTypeOptions: state.buildingTypeOptions,
    }))

  return (
    <>
    <CustomSelect
      options={buildingTypeOptions}
      value={buildingType}
      className={buildingType?.value ? "filter-select building-type-select active" : "filter-select building-type-select"}
      onChange={setBuildingType}
    />
    </>
  )
}

export const OffplanStatusSelect = () => {
  const { offplanStatus, setOffplanStatus, offplanStatusOptions } =
    usePropertyStore((state) => ({
      offplanStatus: state.offplanStatus,
      setOffplanStatus: state.setOffplanStatus,
      offplanStatusOptions: state.offplanStatusOptions,
    }))

  return (
    <CustomSelect
      options={offplanStatusOptions}
      value={offplanStatus}
      className={offplanStatus?.value ? "filter-select offplan-status-select active" : "filter-select offplan-status-select"}
      onChange={setOffplanStatus}
      placeholder="Project Status"
    />
  )
}

export const DeveloperSelect = () => {
  const { developer, setDeveloper, developerOptions } = usePropertyStore(
    (state) => ({
      developer: state.developer,
      setDeveloper: state.setDeveloper,
      developerOptions: state.developerOptions,
    })
  )

  return (
    <CustomSelect
      options={developerOptions}
      value={developer}
      className={developer?.value ? "filter-select developer-select active" : "filter-select developer-select"}
      onChange={setDeveloper}
      placeholder="Developer"
      searchable={true}
    />
  )
}


export const CitySelect = () => {
  const {
    buildingType,
    pDepartment,
    pType,
    minBedroom,
    maxBedroom,
    minPrice,
    maxPrice,
    minAreaSize,
    maxAreaSize,
    sortBy,
    selectedAreas,
    selectedAmenities,
    offplanStatus,
    developer,
    furnished,
    crmId,
    statusType,
  } = usePropertyStore()
  const { city, setCity, cityOptions } = usePropertyStore(
    (state) => ({
      city: state.city,
      setCity: state.setCity,
      cityOptions: state.cityOptions,
    })
  )

  const handleSearch = (e) => {
    setCity(e)
     const url = createResultsUrl({
          departmentVal: pDepartment,
          searchTypeVal: pType,
          areaVal: [],
          minBedVal: minBedroom?.value,
          maxBedVal: maxBedroom?.value,
          minPriceVal: minPrice?.value,
          maxPriceVal: maxPrice?.value,
          minAreaSizeVal: minAreaSize?.value,
          maxAreaSizeVal: maxAreaSize?.value,
          buildingVal: buildingType?.value,
          sortVal: sortBy?.value,
          amenitiesVal: selectedAmenities,
          offplanStatusVal: offplanStatus?.value,
          developerVal: developer?.value,
          furnishVal: furnished,
          crm_id: crmId,
          statusTypeVal:statusType,
          cityVal: e?.value
        })
        if(window.location.pathname === url){

        }
        else {
          // window.location.replace(url)
          navigate(url)
        }
  }

  
  return (
    <CustomSelect
      options={cityOptions}
      value={city}
      className={city?.value ? "filter-select city-select active" : "filter-select city-select"}
      onChange={(e) => {{
        
        handleSearch(e)
      }}
      }
      placeholder="All City"
    />
  )
}
export const BedrromSelect = () => {
  const { minBedroom, setMinBedroom, minBedroomOptions } = usePropertyStore(
    (state) => ({
      minBedroom: state.minBedroom,
      setMinBedroom: state.setMinBedroom,
      minBedroomOptions: state.minBedroomOptions,
    })
  )

  return (
    <CustomSelect
      options={minBedroomOptions}
      value={minBedroom}
      onChange={setMinBedroom}
      className="filter-select bedroom-select"
    />
  )
}

export const MinPriceSelect = () => {
  const {
    minPrice,
    setMinPrice,
    minPriceOptions,
    maxPriceOptions,
    setMinPriceOptions,
    setMaxPriceOptions,
  } = usePropertyStore((state) => ({
    minPrice: state.minPrice,
    setMinPrice: state.setMinPrice,
    minPriceOptions: state.minPriceOptions,
    setMinPriceOptions: state.setMinPriceOptions,
    setMaxPriceOptions: state.setMaxPriceOptions,
    maxPriceOptions: state.maxPriceOptions,
  }))
  const { currencyType } = useGlobalStore()
  useEffect(() => {
    const convertedMinPriceOptions = minPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMinPriceOptions))
      setMinPriceOptions(convertedMinPriceOptions)

    const convertedMaxPriceOptions = maxPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMaxPriceOptions))
      setMaxPriceOptions(convertedMaxPriceOptions)
  
  }, [minPrice])
  return (
    <CustomSelect
      options={minPriceOptions}
      value={minPrice}
      onChange={setMinPrice}
      className={minPrice?.value ? "active filter-select min-price-select" : "filter-select min-price-select"}
    />
  )
}

export const MaxPriceSelect = () => {
  const { currencyType } = useGlobalStore()
  const {
    maxPrice,
    setMaxPrice,
    maxPriceOptions,
    minPriceOptions,
    setMinPriceOptions,
    setMaxPriceOptions,
  } = usePropertyStore((state) => ({
    maxPrice: state.maxPrice,
    setMaxPrice: state.setMaxPrice,
    maxPriceOptions: state.maxPriceOptions,
    minPriceOptions: state.minPriceOptions,
    setMinPriceOptions: state.setMinPriceOptions,
    setMaxPriceOptions: state.setMaxPriceOptions,
  }))
  useEffect(() => {
    const convertedMinPriceOptions = minPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMinPriceOptions))
      setMinPriceOptions(convertedMinPriceOptions)

    const convertedMaxPriceOptions = maxPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMaxPriceOptions))
      setMaxPriceOptions(convertedMaxPriceOptions)
   
  }, [maxPrice])
  return (
    <CustomSelect
      options={maxPriceOptions}
      value={maxPrice}
      onChange={setMaxPrice}
      className={maxPrice?.value ? "active filter-select max-price-select" : "filter-select max-price-select"}
    />
  )
}

export const MaxSizeSelect = () => {
  const { maxAreaSize, setMaxAreaSize, maxAreaSizeOptions } = usePropertyStore(
    (state) => ({
      maxAreaSize: state.maxAreaSize,
      setMaxAreaSize: state.setMaxAreaSize,
      maxAreaSizeOptions: state.maxAreaSizeOptions,
    })
  )

  return (
    <CustomSelect
      options={maxAreaSizeOptions}
      value={maxAreaSize}
      onChange={setMaxAreaSize}
      className="filter-select max-size-select"
    />
  )
}

export const MinSizeSelect = () => {
  const { minAreaSize, setMinAreaSize, minAreaSizeOptions } = usePropertyStore(
    (state) => ({
      minAreaSize: state.minAreaSize,
      setMinAreaSize: state.setMinAreaSize,
      minAreaSizeOptions: state.minAreaSizeOptions,
    })
  )

  return (
    <CustomSelect
      options={minAreaSizeOptions}
      value={minAreaSize}
      onChange={setMinAreaSize}
      className="filter-select min-size-select"
    />
  )
}

export const MinBedroomSelect = () => {
  const { minBedroom, setMinBedroom, minBedroomOptions } = usePropertyStore(
    (state) => ({
      minBedroom: state.minBedroom,
      setMinBedroom: state.setMinBedroom,
      minBedroomOptions: state.minBedroomOptions,
    })
  )

  return (
    <CustomSelect
      options={minBedroomOptions}
      value={minBedroom}
      onChange={setMinBedroom}
      className={minBedroom?.value ? "active filter-select min-bedroom-select" : "filter-select min-bedroom-select"}
    />
  )
}

export const MaxBedroomSelect = () => {
  const { maxBedroom, setMaxBedroom, maxBedroomOptions, pDepartment } =
    usePropertyStore((state) => ({
      maxBedroom: state.maxBedroom,
      setMaxBedroom: state.setMaxBedroom,
      maxBedroomOptions: state.maxBedroomOptions,
      pDepartment: state.pDepartment,
    }))

  const isOffplan = pDepartment === "new_developments"

  let filteredOptions = maxBedroomOptions

  if (isOffplan) {
    // remove studio from options
    filteredOptions = maxBedroomOptions.filter((option) => option.value !== "0")
  }

  return (
    <CustomSelect
      options={filteredOptions}
      value={maxBedroom}
      onChange={setMaxBedroom}
      className={maxBedroom?.value ? "active filter-select max-bedroom-select" : "filter-select max-bedroom-select"}
    />
  )
}

export const SortBySelect = () => {
  const { sortBy, setSortBy } = usePropertyStore((state) => ({
    sortBy: state.sortBy,
    setSortBy: state.setSortBy,
  }))

  return (
    <CustomSelect
      options={sortOptions}
      value={sortBy}
      onChange={setSortBy}
      className="filter-select sort-by-select"
    />
  )
}

export const BuyRentTab = () => {
  const pType = usePropertyStore((state) => state.pType)
  const pDepartment = usePropertyStore((state) => state.pDepartment)

  return (
    <div className="modal-filter-item buy-rent-tab">
      <Tabs
        activeKey={
          pType === "sales"
            ? propertySaleRentUrlOptions[0].value
            : propertySaleRentUrlOptions[1].value
        }
        className="tab-header"
        onChange={(key) => {
          let url = ""

          if (pDepartment === "commercial") {
            // url = `${commercialPropertiesURL}${option.value}/`
          } else if (pDepartment === "residential") {
            url = key
          }

          navigate(addTraillingSlash(url))
              // url = addTraillingSlash(url)
              // window.location.href = url
              // window.location.replace(url)
          // window.location.href = addTraillingSlash(url)
        }}
      >
        <Tab eventKey={propertySaleRentUrlOptions[0].value}>Buy</Tab>
        <Tab eventKey={propertySaleRentUrlOptions[1].value}>Rent</Tab>
      </Tabs>
    </div>
  )
}

export const BuyRentTabBanner = ({setBuyRent, buyRent, setIsOffplan, reset}) => {

  return (
    <div className="modal-filter-item buy-rent-tab">
      <Tabs
        activeKey={
          buyRent
        }
        className="tab-header"
        onChange={(key) => {
          reset()
          setBuyRent(key)
          setIsOffplan(key.value === propertySaleRentUrlOptions[2].value ? true : false)
        }}
      >
        <Tab eventKey={propertySaleRentUrlOptions[0]}>Buy</Tab>
        <Tab eventKey={propertySaleRentUrlOptions[1]}>Rent</Tab>
        <Tab eventKey={propertySaleRentUrlOptions[2]}>Off Plan</Tab>
      </Tabs>
    </div>
  )
}


export const BuildingTypeModalSelect = ({isHide}) => {
  const { buildingType, setBuildingType, buildingTypeOptions } =
    usePropertyStore((state) => ({
      buildingType: state.buildingType,
      setBuildingType: state.setBuildingType,
      buildingTypeOptions: state.buildingTypeOptions,
    }))

  const settings = {
    swipeToSlide: true,
    variableWidth: true,
    infinite: false,
    touchThreshold: 10,
  }

  return (
    <div className="modal-filter-item building-type-select">
      {!isHide &&<h3 className="modal-filter-title">Property Type</h3>}
      <div className={isHide ? "ishide modal-filter-section selection-section" : "modal-filter-section selection-section"}>
        {isHide ?
        buildingTypeOptions.map((option) => (
          <div
            className="selection-item-wrap"
            key={`${option.value}building-type`}
          >
            <div
              className={clsx(
                "selection-item",
                buildingType === option && "active"
              )}
              onClick={() => setBuildingType(option)}
            >
              {option.label}
            </div>
          </div>
        ))
        :
        <Slider {...settings}>
          {buildingTypeOptions.map((option) => (
            <div
              className="selection-item-wrap"
              key={`${option.value}building-type`}
            >
              <div
                className={clsx(
                  "selection-item",
                  buildingType === option && "active"
                )}
                onClick={() => setBuildingType(option)}
              >
                {option.label}
              </div>
            </div>
          ))}
        </Slider>}
      </div>
    </div>
  )
}

export const PriceRangeSelect = ({isHide}) => {
  return (
    <div className="modal-filter-item range-select price-range-select">
      {!isHide &&<h3 className="modal-filter-title">Price Range</h3>}
      <div className="modal-filter-section">
        <MinPriceSelect />
        <MaxPriceSelect />
      </div>
    </div>
  )
}
export const AreaRangeSelect = () => {
  return (
    <div className="modal-filter-item range-select area-range-select">
      <h3 className="modal-filter-title">Size</h3>
      <div className="modal-filter-section">
        <MinSizeSelect />
        <MaxSizeSelect />
      </div>
    </div>
  )
}

export const BedroomRangeSelect = ({isHide}) => {
  return (
    <div className="modal-filter-item range-select bedroom-range-select">
      {!isHide &&<h3 className="modal-filter-title">Bedrooms</h3>}
      <div className="modal-filter-section">
        <MinBedroomSelect />
        <MaxBedroomSelect />
      </div>
    </div>
  )
}

const AmenitySliderCard = ({ isOffPlan, amenity }) => {
  const { isAmenitySelected, sliderOnSwipe } = useAmenityCard(amenity)
  

  return (
    <div className="selection-item-wrap" key={`${amenity.value}-amenity`}>
      <div
        className={clsx("selection-item", isAmenitySelected && "active")}
        {...sliderOnSwipe}
      >
        {amenity.label}
      </div>
    </div>
  )
}

export const AmentiesSliderModalSelect = ({isHide, isOffPlan}) => {
  const settings = {
    swipeToSlide: true,
    variableWidth: true,
    infinite: false,
    touchThreshold: 10,
  }
  const allFeatures = useFeatures()
  let plans = allFeatures?.map((feature) => ({
    label: feature.name,
    value: feature.slug,
  }))
  return (
    <div className="modal-filter-item amenities-select">
      {!isHide &&<h3 className="modal-filter-title">{isOffPlan ? "Features" : "Amenities"}</h3>}
      <div className={isHide ? "ishide modal-filter-section selection-section" : "modal-filter-section selection-section"}>
      {isHide ?<>  {isOffPlan ? plans.map((amenity) => (
             <AmenitySliderCard isOffPlan={isOffPlan} amenity={amenity} key={amenity.value} />
            )) : amenitiesOptions.map((amenity) => (
            <AmenitySliderCard amenity={amenity} key={amenity.value} />
          ))} </>:
        <Slider {...settings}>
          {isOffPlan ? plans.map((amenity) => (
             <AmenitySliderCard isOffPlan={isOffPlan} amenity={amenity} key={amenity.value} />
            )) : 
          amenitiesOptions.map((amenity) => (
            <AmenitySliderCard amenity={amenity} key={amenity.value} />
          ))}
        </Slider>}
      </div>
    </div>
  )
}

const AmenityCheckboxCard = ({ isOffPlan, amenity }) => {
  const { isAmenitySelected, onAmnityClick } = useAmenityCard(amenity)
  console.log(isAmenitySelected)
  return (
    <div className="selection-item-wrap" key={`${amenity.value}-amenity`}>
      <div className={clsx("selection-item", isAmenitySelected && "active")}>
        <div className={clsx("check-box")} onClick={onAmnityClick} 
        title={amenity.label}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="19"
              height="19"
              rx="1.5"
              fill="white"
            />
            {isAmenitySelected && (
              <path
                d="M5.5 10.75L8.89261 14.1426C10.1935 11.073 12.1151 8.33012 14.5 6.07153"
                stroke="#07234B"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            )}
            <rect
              x="0.5"
              y="0.5"
              width="19"
              height="19"
              rx="1.5"
              stroke="#E1E8ED"
            />
          </svg>
          <p className="check-label">{amenity.label}</p>
        </div>
      </div>
    </div>
  )
}



export const AmentiesCheckbox = ({isOffPlan}) => {
  const allFeatures = useFeatures()
  let plans = allFeatures?.map((feature) => ({
    label: feature.name,
    value: feature.slug,
  }))
  return (
    <div className="modal-filter-item amenities-checkbox">
      <h3 className="modal-filter-title">{isOffPlan ? "Features": "Amenities"}</h3>
      {isOffPlan ?
      <div className="modal-filter-section amenity-checkbox-section">
        {/* <AmenityCheckboxCard isOffPlan={isOffPlan} amenity={{"name" : "All", "slug" : "all"}} key={"all"} /> */}
      {plans.map((amenity) => (
        <AmenityCheckboxCard amenity={amenity} key={amenity.value} />
      ))}
    </div>
      :
      <div className="modal-filter-section amenity-checkbox-section">
        {amenitiesOptions.map((amenity) => (
          <AmenityCheckboxCard amenity={amenity} key={amenity.value} />
        ))}
      </div>
      }
    </div>
  )
}

const CustomToggle = React.forwardRef(
  (
    { children, className, onClick, "aria-expanded": ariaExpanded, id },
    ref
  ) => {
    return (
      <button
        ref={ref}
        onClick={(e) => {
          e.preventDefault()
          onClick(e)
        }}
        className={clsx("custom-dropdown-toggle", className)}
        aria-expanded={ariaExpanded}
        id={id}
      >
        <span>{children}</span>
        {ariaExpanded ? <ArrowUp color="white" /> : <ArrowDown color="white" />}
      </button>
    )
  }
)

const CustomMenu = React.forwardRef(
  ({ children, className, "aria-labelledby": labeledBy }, ref) => {
    return (
      <div ref={ref} className={clsx(className)} aria-labelledby={labeledBy}>
        <div className="custom-dropdown-menu">{children}</div>
      </div>
    )
  }
)

export const AreaSlider = ({isHide}) => {
  const MIN_AREA_SIZE = 0
  const MAX_AREA_SIZE = 15100
  const { maxAreaSizeVal, minAreaSizeVal } = useUrlData()

  const [minValue, setMinValue] = React.useState(Number(minAreaSizeVal) || 0)
  const [maxValue, setMaxValue] = React.useState(
    Number(maxAreaSizeVal) || MAX_AREA_SIZE
  )

  const setMinAreaSize = usePropertyStore((state) => state.setMinAreaSize)
  const setMaxAreaSize = usePropertyStore((state) => state.setMaxAreaSize)

  useEffect(() => {
    const sliderInputWrap = document.getElementById("slider-input-wrap")

    const eventOut = (e) => {
      if (!sliderInputWrap.contains(e.target)) {
        setMinAreaSize({
          label: formatNumber(minValue),
          value: minValue,
        })
        if (maxValue === MIN_AREA_SIZE || maxValue >= MAX_AREA_SIZE)
          setMaxAreaSize(null)
        else
          setMaxAreaSize({
            label: formatNumber(maxValue),
            value: maxValue,
          })
      }
    }

    document.addEventListener("click", eventOut)
    document.addEventListener("focusin", eventOut)

    return () => {
      document.removeEventListener("click", eventOut)
      document.removeEventListener("focusin", eventOut)
    }
  }, [minValue, maxValue, setMinAreaSize, setMaxAreaSize])

  return (
    <div className="slider-input-wrap" id="slider-input-wrap">
      {!isHide &&<p className="label">Property Size</p>}
      <ReactSlider
        className="slider-input"
        thumbClassName="slider-thumb"
        trackClassName="slider-track"
        value={[
          minValue,
          maxValue === MIN_AREA_SIZE ? MAX_AREA_SIZE : maxValue,
        ]}
        onChange={(value) => {
          setMinValue(value[0])
          setMaxValue(value[1])
        }}
        ariaLabel={["Lower thumb", "Upper thumb"]}
        ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
        renderThumb={(props) => (
          <div {...props}>
            <div className="thumb-icon" />
          </div>
        )}
        pearling
        step={100}
        min={MIN_AREA_SIZE}
        max={MAX_AREA_SIZE}
        minDistance={500}
      />
      <div className="values-section">
        <p className="value min-value">{SizeConvert(minValue)}</p>
        <p className="value max-value">
          {maxValue >= MAX_AREA_SIZE || maxValue === MIN_AREA_SIZE
            ? SizeConvert(15000, "+")
            : SizeConvert(maxValue)}
        </p>
      </div>
    </div>
  )
}

export const AreaSliderDropdown = () => {
  const {minAreaSize, maxAreaSize} = usePropertyStore()
  return (
    <Dropdown className={minAreaSize?.value || maxAreaSize?.value ? "active filter-dropdown" : "filter-dropdown"} autoClose="outside">
      <Dropdown.Toggle as={CustomToggle} className="filter-dropdown-toggle">
        {/* <span>{minAreaSize?.value || maxAreaSize?.value ? getSizetext(minAreaSize?.value, maxAreaSize?.value)  : "Size"}</span> */}
        <span>Size</span>
      </Dropdown.Toggle>

      <Dropdown.Menu as={CustomMenu} className="filter-dropdown-menu">
        <AreaSlider />
      </Dropdown.Menu>
    </Dropdown>
  )
}

export const FurnishedCheckbox = () => {
  const { furnished, setFurnished } = usePropertyStore((state) => ({
    furnished: state.furnished,
    setFurnished: state.setFurnished,
  }))

  return (
    <div className="modal-filter-item amenities-checkbox">
      <h3 className="modal-filter-title">Furnishing</h3>
      <div className="modal-filter-section amenity-checkbox-section">
        <div className={clsx("selection-item", furnished && "active")}>
          <div
            className={clsx("check-box")}
            onClick={() => {
              setFurnished(!furnished)
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="19"
                height="19"
                rx="1.5"
                fill="white"
              />
              {furnished && (
                <path
                  d="M5.5 10.75L8.89261 14.1426C10.1935 11.073 12.1151 8.33012 14.5 6.07153"
                  stroke="#07234B"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              )}
              <rect
                x="0.5"
                y="0.5"
                width="19"
                height="19"
                rx="1.5"
                stroke="#E1E8ED"
              />
            </svg>
            <p className="check-label">Furnished</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export const FilterDropdown = ({
  toggleText,
  leftText,
  LeftComponent,
  rightText,
  RightComponent,
  className,
}) => {
  return (
    <Dropdown
      className={clsx("filter-dropdown", className)}
      autoClose="outside"
    >
      <Dropdown.Toggle as={CustomToggle} className="filter-dropdown-toggle">
        <span>{toggleText}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu as={CustomMenu} className="filter-dropdown-menu">
        <div className="menu-item-wrap">
          <p className="label">{leftText}</p>
          <LeftComponent />
        </div>
        <div className="menu-item-wrap">
          <p className="label">{rightText}</p>
          <RightComponent />
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export const SearchButton = ({ children, onClick }) => {
  const { handleSearch } = useSearch({ onClick })

  return (
    <button className="button button-orange" onClick={handleSearch}>
      {children || (
        <>
        <SearchIcon color="white" />
          <span>Search</span>
        </>
      )}
    </button>
  )
}

export const ApplyFilter = ({ children, onClick, handleClose }) => {
  const { handleSearch } = useSearch({ onClick })

  return (
    <button className="button button-orange" onClick={() => {handleSearch();handleClose()}}>
      {children || (
        <>
          <span>Apply Filter</span>
        </>
      )}
    </button>
  )
}
